







































import { AdminRouteName } from '@/constants';
import { authHelper } from '@homeserve/vue-auth-plugin';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component
export default class Drawer extends Vue {
  @State('userAuthenticated', { namespace: 'auth' })
  public readonly isAuthenticated!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly visible!: boolean;

  public isVisible = this.visible;

  public async logout() {
    await authHelper.logout(this.$store);

    this.$router.push({ name: 'home' });
  }

  @Emit('toggle')
  public onInput(visibility) {
    return visibility;
  }

  @Watch('visible', { immediate: true })
  private onVisibleChanged(visible: boolean) {
    this.isVisible = visible;
  }

  public get AdminRouteName() {
    return AdminRouteName;
  }
}
